import React from 'react';
import hand from "../../images/hand.svg";

export class CriticalNetworkModal extends React.Component {

  tryAgainTimeout;

  constructor (props) {
    super(props);

    this.state = {
      showTryAgain: false,
    }

    this.retryPressed = this.retryPressed.bind(this);
  }

  componentDidMount() {
    this.tryAgainTimeout = setTimeout(() => {
      this.setState({ showTryAgain: true });
      this.tryAgainTimeout = undefined;
    }, 10000); // Wait to show show "Try Again" button for 10 seconds to try and get student to actually get their teacher
  }

  componentWillUnmount() {
    if (this.tryAgainTimeout) {
      clearTimeout(this.tryAgainTimeout);
    }
  }

  retryPressed() {
    this.props.continue();
  }

  render() {
    return (
      <div className="restartModal">
        <div className="alert">Internet Issue</div>
        <div className="iconContainer">
          <img className="icon error" src={hand} alt=""/>
        </div>
        <div className="explanation labelFontOverride">See this <a href="https://help.amiralearning.com/s/article/Understanding-Amira-Error-Messages" target="_blank">help link</a> for troubleshooting steps or contact <a mailto="support@amiralearning.com">support@amiralearning.com</a> for assistance. Error code 0005.</div>
        {this.state.showTryAgain &&
          <button className="restartButton primaryButton" style={{ marginTop: '4vh' }} onClick={this.retryPressed} type="button">Try Again</button>
        }
      </div>
    );
  }
}
